import {lazy, trigger, filter} from './lang.js';
import {doc} from './documentation.js';

const len = (arr) => arr.length;
const last = (arr) => arr[len(arr) - 1];

export const rateMatches =
      (history, stepNumber, rate) =>
      last(history) && (stepNumber - last(history).stepNumber) === Math.floor(rate);
      
export const repeat = (repeats, rate) => {
    var history = [];
    return (stepData, stepNumber, time) => {
        if (rateMatches(history, stepNumber, lazy(rate))) {
            let trig = stepData === undefined ?
                {... last(history), stepNumber, time} :
                {stepData, stepNumber, time};
            let ret = stepData === undefined ? trigger(trig) : filter(true);
            if (stepData !== undefined) {
                // clear
                history = [trig];
            } else {
                history = [... history, trig];
            }
            if (len(history) > lazy(repeats)) {
                history = [];
            }
            return ret;
        }

        if (stepData !== undefined) {
            history = [{stepData, stepNumber, time}];
            return filter(true);
        } else {
            return filter(false);
        }
    };
};

doc(
    "beat",
    {
        step: "The step within the beat at which this executes the ifCond condition",
        beat: "The total number of steps within which we determine if the step has occured",
        ifCond: "The condition that is executed when the step is reached",
        elseCond: "The condition that is executed otherwise"
    },
    "Conditions on a certain step within a beat. For example, beat(0,32,a,b) executes a on the 1st beat of every bar, and executes b on every other step");

export const beat = (step, beat=32, ifCond, elseCond) => {
    return (stepData, stepNumber, time) => {
        let args = [stepData, stepNumber, time];
        if (stepNumber % lazy(beat, ...args) === lazy(step, ...args)) {
            return lazy(ifCond, ...args);
        } else if (elseCond) {
            return lazy(elseCond, ...args);
        } else {
            return filter(true);
        }
    };
};

// gate([1,1,1,1,0,0,0,1]) => will gate steps 0,1,2,3,4 gate mask  5,6,7,8, and gate 9
// i.e. it will allow them to go thru

doc(
    "gate",
    {
        stepsLists: "An array where each element is a number from 0-1 determing the probability that we allow a trigger occuring at that step to pass through"
    },
    "Control which steps are triggered within a beat, probabilistically. gate([1, 1]) allows every trigger to occur.");
export const gate = (x) => {
    return (stepData, stepNumber, time) => {
        let steps = lazy(x, stepData, stepNumber, time);
        if (typeof steps === "number") {
            steps = convertNumberToList(steps);
        }
        let stepProb = lazy(
            steps[Math.floor(stepNumber / 2) % steps.length],
            stepData,
            stepNumber,
            time);
        if (Math.random() < stepProb) {
            return filter(true);
        } else {
            return filter(false);
        }
    };
};

doc(
    "shift",
    {
        "list": "The list that we wish to shift",
        "shiftNumber": "The number of indices to shift by"
    },
    "Shifts a list by a number of indices, on each trigger"
);
export const shift = (arr, shiftNum=1) => {
    let _arr = [...arr];
    return (stepData, stepNumber, time) => {
        for (let i=0; i < shiftNum; i++) {
            let x = _arr.shift();
            _arr.push(x);
        }
        return _arr;
    };
};

export const convertNumberToList = (steps) => {
    let num = steps;
    let _steps = []; 
    while (steps > 0) {
        _steps.push(steps % 2);
        steps = Math.floor(steps / 2);
    }
    while (_steps.length < 16) {
        _steps.push(0);
    }
    return _steps;
};

export const convertListToNumber = (list) => {
    let number=0;
    for (let i=0; i < list.length; i++) {
        let key = i;
        if (list[key]) {
            number += Math.pow(2, key);
        }
    }
    return number;
};

